import { Drawer, Group, Modal, type ModalProps } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import type { ReactNode } from 'react'

export interface ResponsiveDialogProps {
  opened: boolean
  onClose: () => void
  title: ReactNode
  size?: ModalProps['size']
  /** Buttons pinned to the bottom (Cancel / Save) */
  footer?: ReactNode
  children: ReactNode
}

/** Centered dialog on desktop, bottom sheet on phones. */
export function ResponsiveDialog({ opened, onClose, title, size = 'lg', footer, children }: ResponsiveDialogProps) {
  const phone = useMediaQuery('(max-width: 47.99em)')
  const actions = footer && (
    <Group justify="flex-end" gap="sm" mt="lg" pb={phone ? 'env(safe-area-inset-bottom)' : undefined}>
      {footer}
    </Group>
  )
  if (phone) {
    return (
      <Drawer
        opened={opened}
        onClose={onClose}
        title={title}
        position="bottom"
        radius="xl"
        // Full width, as tall as the content (Mantine's bottom drawer is full height by default)
        styles={{ content: { height: 'auto', maxHeight: '92dvh' } }}
      >
        {children}
        {actions}
      </Drawer>
    )
  }
  return (
    <Modal opened={opened} onClose={onClose} title={title} size={size}>
      {children}
      {actions}
    </Modal>
  )
}
